// extracted by mini-css-extract-plugin
export default {"wrapper":"SignDetails_wrapper__PSx-2","cosigner":"SignDetails_cosigner__D0fS9"};